function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var disabledColor = 'grey.300';

var getCardAppearence = function getCardAppearence(props) {
  var isActive = props.isActive;
  var hoverBackgroundColor = isActive ? 'white' : 'grey.100';
  var styles = {
    borderColor: 'grey.200',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '4px 4px 0px 0px',
    backgroundColor: 'grey.100',
    // Overwrite base button hover
    '&:hover': {
      backgroundColor: hoverBackgroundColor
    },
    '&:focus': {
      backgroundColor: hoverBackgroundColor
    },
    '&[disabled]': {
      color: disabledColor,
      borderColor: 'grey.200',
      backgroundColor: hoverBackgroundColor
    }
  };

  if (isActive) {
    return _objectSpread(_objectSpread({}, styles), {}, {
      backgroundColor: 'white',
      borderBottom: '0px',
      boxShadow: '0px 0px 8px rgba(9, 10, 12, 0.16)'
    });
  }

  return styles;
};

var getDefaultAppearence = function getDefaultAppearence(props) {
  var styles = {
    borderWidth: '0px',
    backgroundColor: 'white',
    // Overwrite base button hover
    '&:hover': {
      backgroundColor: 'white',
      borderRadius: 0
    },
    '&:focus': {
      backgroundColor: 'white',
      borderRadius: 0
    },
    '&[disabled]': {
      color: disabledColor,
      backgroundColor: 'white'
    }
  };

  if (props.isActive) {
    return _objectSpread(_objectSpread({}, styles), {}, {
      zIndex: 1 // for boxShadow visibility

    });
  }

  return styles;
};

var appearances = function appearances(props) {
  return {
    card: getCardAppearence(props),
    "default": getDefaultAppearence(props)
  };
};

var getAppearance = function getAppearance(props) {
  return appearances(props)[props.appearance];
};

export var _getButtonBaseStyle = function _getButtonBaseStyle(props) {
  var isActive = props.isActive,
      centered = props.centered;
  return _objectSpread({
    width: '100%',
    flexDirection: 'column',
    alignItems: centered ? 'center' : 'inherit',
    fontWeight: 400,
    textAlign: centered ? 'center' : 'inherit',
    textTransform: 'none',
    color: isActive ? 'white' : 'grey.600',
    padding: '8px 24px'
  }, getAppearance(props));
};

var getActiveTabTitleAppearances = function getActiveTabTitleAppearances(props) {
  var isActive = props.isActive,
      appearance = props.appearance;

  if (!isActive) {
    return {};
  }

  var appearanceMapping = {
    card: {
      color: 'black'
    },
    "default": {
      color: 'blue.500'
    }
  };
  return appearanceMapping[appearance];
};

export var _getTitleBaseStyle = function _getTitleBaseStyle(props) {
  return _objectSpread({
    letterSpacing: '0.01em',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    color: 'grey.600'
  }, getActiveTabTitleAppearances(props));
};